import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { queryClient } from './queryClient.js';
import { LanguageProvider } from './context/LanguageContext.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import AppFeedback from './components/AppFeedback.jsx';
import './styles/global.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <AuthProvider>
          <AppFeedback>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AppFeedback>
        </AuthProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </StrictMode>
);
